import { render, staticRenderFns } from "./GoodsInfoCellPrice.vue?vue&type=template&id=38b8af16&scoped=true"
import script from "./GoodsInfoCellPrice.vue?vue&type=script&lang=js"
export * from "./GoodsInfoCellPrice.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfoCellPrice.vue?vue&type=style&index=0&id=38b8af16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b8af16",
  null
  
)

export default component.exports